export default "__VITE_ASSET__D$WCNZXR__"